"use strict";
var coverage_view_model_1 = require("./coverage-view.model");
exports.CoverageViewModel = coverage_view_model_1.CoverageViewModel;
var rental_information_view_model_1 = require("./rental-information-view.model");
exports.RentalInformationViewModel = rental_information_view_model_1.RentalInformationViewModel;
var coverage_container_view_model_1 = require("./coverage-container-view.model");
exports.CoverageContainerViewModel = coverage_container_view_model_1.CoverageContainerViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/coverages/index.js